import DealPrice from './DealPrice';

export default DealPrice;
